import { render, staticRenderFns } from "./topicEdit.vue?vue&type=template&id=4379d4c3"
import script from "./topicEdit.vue?vue&type=script&lang=js"
export * from "./topicEdit.vue?vue&type=script&lang=js"
import style0 from "./topicEdit.vue?vue&type=style&index=0&id=4379d4c3&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4379d4c3')) {
      api.createRecord('4379d4c3', component.options)
    } else {
      api.reload('4379d4c3', component.options)
    }
    module.hot.accept("./topicEdit.vue?vue&type=template&id=4379d4c3", function () {
      api.rerender('4379d4c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promotion/topicEdit.vue"
export default component.exports